import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { RAIL_LABEL } from "../../../constants/configuration.const";
import DragHandleIcon from "@mui/icons-material/DragIndicator";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSnackbar } from "notistack";
import {
    Autocomplete,
    Button,
    Grid,
    IconButton,
    Paper,
    TextField,
    Tooltip,
    createFilterOptions,
    styled,
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import {
    NO_CONTENT_PLAYLIST,
    THEMATIC_VALIDATION,
} from "../LandingPage/constants";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import { ChromePicker } from "react-color";
import { ColorPicker } from "../../UI/Common/ColorPicker";
import GeneralModalV1 from "../../UI/atoms/Popup/GeneralModalV1";
import { getPlaylistCount } from "../../../utilities/helpers/helperService";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));

const EpisodicContentCurationCard = forwardRef(
    (
        {
            handleFormChange,
            playlist,
            dragHandleProps,
            onClickDelete,
            onClickEdit,
            onClickAdd,
            data,
            className,
            hideAddButton,
            allowEdit,
            handleRail,
            handleRailTitle,
        }: any,
        ref: any
    ) => {
        const initialFormValue: any = {
            title: "",
            playlistId: "",
            playlistCount: null,
        };

        // hooks
        const [showForm, setShowForm] = useState(false);
        const { enqueueSnackbar } = useSnackbar();
        const episodicRailRef = useRef<any>(null);
        const [errorMessage, setErrorMessage] = useState("");
        const [enableTitleEdit, setEnableTitleEdit] = useState(false);
        const [initialFormValueState, setInitialFormValueState] =
            useState(initialFormValue);
        const [playlistInfo, setPlaylistInfo] = useState<any>([]);
        const [isOpen, setIsOpen] = React.useState(false);
        const [episodicRailTitle, setEpisodicRailTitle] = useState("");
        const [formValid, setFormValid] = useState<any>(null);
        const [formChangeKey, setFormChange] = useState<any>(null);

        useImperativeHandle(
            ref,
            () => ({
                onOpenForm,
                isValid,
                handleSubmit,
                getFormValue,
            }),
            [showForm, formChangeKey, formValid]
        );

        // manual formchange event
        const onFormChange = (field: string, value: string) => {
            console.log("formchange happ", field, value);
            setFormChange({ field, value });
        };

        // for the parent to access tje form isValid state
        const isValid = () => {
            console.log(formValid);
            // if form is already opened, get data from the formRef
            // else get it from the state
            if (showForm) {
                console.log(episodicRailRef.current);
                return episodicRailRef.current.isValid;
            } else {
                return formValid?.isValid == null ? null : formValid?.isValid;
            }
        };

        // for the parent to access the form submit
        const handleSubmit = () => {
            setShowForm(true);
            setTimeout(() => {
                episodicRailRef.current.handleSubmit();
            }, 100);
        };
        const getFormValue = () =>
            episodicRailRef?.current?.values || formValid.values;

        useEffect(() => {
            checkIfKeyPresent(data);
            console.log("useeffect", data);
            setInitialFormValueState({
                playlistId: data?.playlistId || "",
                title: data?.title || "",
            });
        }, [data]);

        // on first time creation, there will not be a key called "description". this is make the form valid to false
        const checkIfKeyPresent = (data: any) => {
            if (!data) return;
            const keys = Object.keys(data);
            if (!keys.includes("title")) {
                setFormValid({ isValid: false });
            }
        };

        const handleOpenOptions = () => {
            setIsOpen(true);
        };

        const handleCloseOptions = () => {
            setIsOpen(false);
        };

        useEffect(() => {
            if (playlist && playlist.length) setPlaylistInfo(playlist);
        }, [playlist]);

        useEffect(() => {
            if (data) {
                setEpisodicRailTitle(data?.railTitle);
            }
        }, [data]);

        useEffect(() => {
            if (episodicRailRef?.current && episodicRailTitle) {
                episodicRailRef.current.setFieldValue(
                    "railTitle",
                    episodicRailTitle || ""
                );
            }
        }, [episodicRailTitle && episodicRailRef]);

        //USED BY THE PARENT COMPONENT FOR OPENING EXPANDING RAIL
        const onOpenForm = () => {
            setShowForm(true);
            setTimeout(() => {
                episodicRailRef.current.validateForm();
            }, 100);
        };

        // when closing the rail, make sure to persist the form validate & the form values
        const onCloseRail = () => {
            const { isValid, values } = episodicRailRef.current;
            setFormValid({ isValid, values });
            setShowForm(false);
            handleRail(episodicRailRef.current.values);
        };

        // on click on save button inside the rail
        const saveEpisodicRail = () => {
            // moves data to the parent
            const { isValid, values } = episodicRailRef.current;
            setFormValid({ isValid, values });
            handleRail(episodicRailRef.current.values);
            enqueueSnackbar("Episodic Rail Added", {
                variant: "info",
                autoHideDuration: 2000,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                },
            });
            setErrorMessage("");
            setShowForm(false);
        };

        // USED BY AUTOCOMPLETE FILTER
        const filterOptions = createFilterOptions({
            matchFrom: "any",
            stringify: (option: any) => option.name + option.id,
        });

        const renderOptionsInitial = (options: any) => {
            if (typeof options == "string") {
                const filterPlaylist = playlistInfo.filter(
                    (list: any) => list.id === options
                );
                if (filterPlaylist.length > 0) {
                    return (
                        filterPlaylist[0].name + " - " + filterPlaylist[0].id
                    );
                } else {
                    return "";
                }
            } else if (typeof options == "object") {
                return options.name + " - " + options.id;
            }
        };

        return (
            <div
                className={
                    "curation-list-card-container d-flex j-center curation-card"
                }
            >
                <div {...dragHandleProps} className="d-flex float-center">
                    <DragHandleIcon className="drag-handle" />
                </div>
                <div className="curation-list-card hero-carousal-card-height">
                    {/* Row One */}
                    <div {...dragHandleProps} className="d-flex j-space">
                        <span className="curation-title">
                            #{RAIL_LABEL[data.template]}
                        </span>
                        <div className="f-bold">
                            {enableTitleEdit ? (
                                <>
                                    <TextField
                                        label="Epsiodic Rail Title"
                                        id="outlined-size-small"
                                        value={episodicRailTitle}
                                        size="small"
                                        onChange={(e: any) => {
                                            const title = e.target.value || "";
                                            setEpisodicRailTitle(title);
                                        }}
                                    />
                                    <Tooltip title="Save Title">
                                        <IconButton
                                            disabled={
                                                episodicRailTitle.length == 0
                                            }
                                        >
                                            <Check
                                                onClick={() => {
                                                    setEnableTitleEdit(false);
                                                    handleRailTitle(
                                                        episodicRailTitle
                                                    );
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Cancel">
                                        <IconButton>
                                            <Close
                                                onClick={() => {
                                                    setEpisodicRailTitle(
                                                        data?.railTitle
                                                    );
                                                    setEnableTitleEdit(false);
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            ) : (
                                <span
                                    onClick={() =>
                                        allowEdit && setEnableTitleEdit(true)
                                    }
                                >
                                    {" "}
                                    {episodicRailTitle}
                                </span>
                            )}
                            <div></div>
                        </div>
                        <div>
                            <span
                                className="cursor-pointer delete-circle-style"
                                onClick={onClickDelete}
                            >
                                {allowEdit && <DeleteIcon />}
                            </span>
                        </div>
                    </div>

                    {/* row content */}

                    {showForm && (
                        <Formik
                            innerRef={episodicRailRef}
                            initialValues={initialFormValueState}
                            enableReinitialize
                            validationSchema={Yup.object({
                                title: Yup.string()
                                    .required("Title is required")
                                    .max(
                                        THEMATIC_VALIDATION.TITLE,
                                        `Title must not exceed ${THEMATIC_VALIDATION.TITLE} characters`
                                    ),
                                playlistId: Yup.string().required(
                                    "Playlist ID is required"
                                ),
                                playlistCount: Yup.number().min(1),
                            })}
                            onSubmit={saveEpisodicRail}
                        >
                            {({
                                values,
                                handleChange,
                                touched,
                                errors,
                                setFieldValue,
                                setFieldTouched,
                                setValues,
                            }: any) => (
                                <Form>
                                    <Grid className="p-1" container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Field
                                                name={`title`}
                                                as={TextField}
                                                label="Title Text"
                                                fullWidth
                                                value={values[`title`]}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    onFormChange(
                                                        "title",
                                                        e.target.value
                                                    );
                                                }}
                                                size={"small"}
                                                className="mb-1 w-95"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                error={
                                                    touched?.title &&
                                                    errors.title
                                                }
                                                helperText={
                                                    touched.title &&
                                                    errors.title
                                                }
                                                disabled={!allowEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            {/* <InputLabel shrink>Playlist Id</InputLabel> */}
                                            <div>
                                                <Autocomplete
                                                    id="bcPlaylistId"
                                                    options={playlistInfo}
                                                    filterOptions={
                                                        filterOptions
                                                    }
                                                    value={values.playlistId}
                                                    includeInputInList
                                                    size="small"
                                                    open={isOpen}
                                                    onChange={async (
                                                        e,
                                                        value
                                                    ) => {
                                                        onFormChange(
                                                            "playlistId",
                                                            value?.id
                                                        );
                                                        await setFieldTouched(
                                                            `playlistId`,
                                                            true
                                                        );
                                                        const playlistCount =
                                                            await getPlaylistCount(
                                                                value?.id
                                                            );
                                                        const formValue = {
                                                            ...values,
                                                            playlistId:
                                                                value?.id || "",
                                                            playlistCount,
                                                        };
                                                        setValues({
                                                            ...formValue,
                                                        });
                                                    }}
                                                    onOpen={handleOpenOptions}
                                                    onClose={handleCloseOptions}
                                                    getOptionLabel={(
                                                        options: any
                                                    ) => {
                                                        return (
                                                            renderOptionsInitial(
                                                                options
                                                            ) || ""
                                                        );
                                                    }}
                                                    disabled={!allowEdit}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="playlistId"
                                                            label="BC Playlist Id"
                                                            value={
                                                                values.playlistId
                                                            }
                                                            variant="outlined"
                                                            error={
                                                                touched.playlistId &&
                                                                (Boolean(
                                                                    errors.playlistId
                                                                ) ||
                                                                    Boolean(
                                                                        errors.playlistCount
                                                                    ))
                                                            }
                                                            helperText={
                                                                touched.playlistId &&
                                                                values[
                                                                    `playlistId`
                                                                ] &&
                                                                !values[
                                                                    `playlistCount`
                                                                ] &&
                                                                NO_CONTENT_PLAYLIST
                                                            }
                                                            {...params}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    )}

                    <div
                        {...dragHandleProps}
                        className={`${!showForm && "mt-3 "}d-flex j-space`}
                    >
                        {!showForm && (
                            <>
                                <span
                                    onClick={onOpenForm}
                                    className="curation-edit cursor-pointer"
                                >
                                    Edit Rail
                                </span>
                                <KeyboardArrowDownIcon
                                    className="cursor-pointer"
                                    onClick={onOpenForm}
                                />
                            </>
                        )}
                    </div>

                    {showForm && (
                        <div
                            {...dragHandleProps}
                            className="d-flex flex-column"
                        >
                            <div className="d-flex j-end">
                                {allowEdit && (
                                    <Button
                                        onClick={() =>
                                            episodicRailRef.current.handleSubmit()
                                        }
                                        className="max-content-width float-center align-right mr-2"
                                        variant="contained"
                                        type="button"
                                    >
                                        Save
                                    </Button>
                                )}
                                <KeyboardArrowUpIcon
                                    className="align-right cursor-pointer"
                                    onClick={onCloseRail}
                                />
                            </div>
                            {errorMessage && (
                                <div className="text-danger d-flex j-end publish-error-text">
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div
                    {...dragHandleProps}
                    className="curation-list-card-container-span"
                >
                    {!hideAddButton && allowEdit && (
                        <Tooltip title="Add New Rail">
                            <span
                                className="cursor-pointer add-circle-style"
                                onClick={onClickAdd}
                            >
                                <AddCircleOutlineIcon />
                            </span>
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    }
);

export default EpisodicContentCurationCard;
